import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/solicitacao/linha';
const BASE_LINE_MANAGE = '/linha/gestao';

const lineEndpoints = {
    getUsersPermissioariesPagination: ({ page, size, request = {} }) => {
        return stipAxios.post(`/usuario/permissionarios/pages/${page}/${size ? size : 10}`, request);
    },
    getLines: (params, context = EXTERNAL_CONTEXT) => {
        const { page, size, request } = params;
        return stipAxios.post(`${context}${BASE_ENDPOINT}/pages/${page}/${size ? size : 10}`, request);
    },
    getLinePermissionaries: (cdLinha) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/${cdLinha}/permissionarios`),
    getGrants: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/outorga`),
    getServices: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/servico`),
    getScheduleBoard: (cdLinha, context = EXTERNAL_CONTEXT) =>
        stipAxios.get(`${context}${BASE_ENDPOINT}/quadro-horario/${cdLinha}`),
    saveRequest: (payload, context = EXTERNAL_CONTEXT) => stipAxios.post(`${context}${BASE_ENDPOINT}/save`, payload),
    finishRequest: (cdSolicitacao) =>
        stipAxios.put(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/finalizar/${cdSolicitacao}`, {}),
    cancelRequest: (cdSolicitacao, payload = {}, context = EXTERNAL_CONTEXT) =>
        stipAxios.put(`${context}${BASE_ENDPOINT}/cancelar/${cdSolicitacao}`, payload),
    getAllLinesByTermoContrato: (nuTermoContrato, context = EXTERNAL_CONTEXT) => {
        let baseUrl = BASE_LINE_MANAGE;
        if (context === EXTERNAL_CONTEXT) baseUrl = `${EXTERNAL_CONTEXT}${BASE_ENDPOINT}`;
        return stipAxios.get(`${baseUrl}/find-all-by-termo/${nuTermoContrato}`);
    },
    // ###############################################################################################
    // ########################################## GESTOR #############################################
    // ###############################################################################################
    getLine: (cdLinha) => stipAxios.get(`${BASE_LINE_MANAGE}/${cdLinha}`),
    saveLine: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/save`, data),
    inactivateLine: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/inativar`, data),
    getProcess: ({ id, numero }) => stipAxios.post(`${BASE_LINE_MANAGE}/get-processo`, { id, numero }),
    getRequestByProcessId: ({ id }) => stipAxios.get(`${BASE_LINE_MANAGE}/get-solicitacao-by-cdprocesso/${id}`),
    getSituations: () => stipAxios.get(`${BASE_LINE_MANAGE}/situacoes`),
    getLineWithSchedules: () => stipAxios.get(`${BASE_LINE_MANAGE}/find-all-qh-vigente`),
    getLocationsFromOrigin: () => stipAxios.get(`${BASE_LINE_MANAGE}/find-all-localidades`),
    getAllLocations: () => stipAxios.get(`${BASE_LINE_MANAGE}/localidades`),

    //Gestor Condutor Substituto -----------------------------------------------------------
    getSubstituteConductors: (params) => {
        const { page, size, request } = params;
        return stipAxios.post(`${BASE_LINE_MANAGE}/condutores-substitutos/pages/${page}/${size ? size : 10}`, request);
    },
    getSubstituteConductor: (cdCondutorSubstituto) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/condutores-substitutos/${cdCondutorSubstituto}`),
    saveSubstituteConductor: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/condutores-substitutos/save`, data),
    sendConductorsToProcess: ({ cdCertificado, cdProcesso, nuProcesso }) =>
        stipAxios.post(`${BASE_LINE_MANAGE}/condutores-substitutos/insere-documento-processo`, {
            cdCertificado,
            cdProcesso,
            nuProcesso,
        }),
    sendConductorsToRequest: ({ cdCertificado, cdSolicitacao }) =>
        stipAxios.post(`${BASE_LINE_MANAGE}/condutores-substitutos/insere-documento-solicitacao`, {
            cdCertificado,
            cdSolicitacao,
        }),
    generateConductorFile: (cdCondutorSubstituto) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/condutores-substitutos/${cdCondutorSubstituto}/documento/gerar`),
    inactivateConductor: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/condutores-substitutos/inativar`, data),
    getDefaultExpirationDate: () =>
        stipAxios.get(`${BASE_LINE_MANAGE}/condutores-substitutos/validade-padrao-carteira`),

    //Gestor Transferencia -----------------------------------------------------------
    saveTransfer: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/transferencias/save`, data),
    getTransfers: (params) => {
        const { page, size, request } = params;
        return stipAxios.post(`${BASE_LINE_MANAGE}/transferencias/pages/${page}/${size ? size : 10}`, request);
    },

    //Gestor Tarifas -----------------------------------------------------------
    saveFare: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/tarifas/save`, data),
    getFares: (params) => {
        const { page, size, request } = params;
        return stipAxios.post(`${BASE_LINE_MANAGE}/tarifas/pages/${page}/${size ? size : 10}`, request);
    },

    //Gestor Permissionários -----------------------------------------------------------
    getPermissionary: (cdPermissionario) => stipAxios.get(`${BASE_LINE_MANAGE}/permissionarios/${cdPermissionario}`),
    getPermissionaryPendencies: ({ deCpfCnpj = null, cdVeiculo = null }) => {
        const data = { deCpfCnpj: deCpfCnpj, cdVeiculo: cdVeiculo };
        return stipAxios.post(`${BASE_LINE_MANAGE}/permissionarios/pendencias`, data);
    },
    getPermissionaryByDocument: (document) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/permissionarios/find-by-documento/${document}`),
    getCompanyOrPermissionaryByDocument: (document) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/permissionarios/find-permissionario-ou-empresa-by-documento/${document}`),
    getDateReference: () => stipAxios.get(`${BASE_LINE_MANAGE}/permissionarios/referencias-data`),
    savePermissionary: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/permissionarios/save`, data),
    inactivatePermissionary: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/permissionarios/inativar`, data),
    getAllPermissionaries: () => stipAxios.get(`${BASE_LINE_MANAGE}/permissionarios/find-all`),
    getPermissionaries: (params) => {
        const { page, size, request } = params;
        return stipAxios.post(`${BASE_LINE_MANAGE}/permissionarios/pages/${page}/${size ? size : 10}`, request);
    },
    getCepeByCdVeiculo: (cdVeiculo) => stipAxios.get(`${BASE_LINE_MANAGE}/permissionarios/veiculo/${cdVeiculo}/cepes`),
    getCepe: (cdLinhaPermissionario) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/permissionarios/${cdLinhaPermissionario}/cepe`),
    generateCepe: (params) => stipAxios.post(`${BASE_LINE_MANAGE}/permissionarios/cepe/gerar`, params),
    sendCepeWithProcess: (request) =>
        stipAxios.post(`${BASE_LINE_MANAGE}/permissionarios/insere-cepe-processo`, request),
    sendCepeWithRequest: (request) =>
        stipAxios.post(`${BASE_LINE_MANAGE}/permissionarios/insere-cepe-solicitacao`, request),
    getVehiclesByDocument: (params) => {
        const { page, size, deCpfCnpj } = params;
        return stipAxios.get(`${EXTERNAL_CONTEXT}/veiculo/vistoriados/${deCpfCnpj}/${page}/${size ? size : 10}`);
    },
    getActiveVehicleByPermissionary: (cdLinhaPermissionario) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}/permissionario/veiculo-ativo/${cdLinhaPermissionario}`),

    getSubstituteConductorsByPermissionary: (cdLinhaPermissionario) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/condutores-substitutos/find-all-by-permissionario/${cdLinhaPermissionario}`),

    //Gestor Itinerario ----------------------------------------------------------------
    getItineraries: (params) => {
        const { page, size, request } = params;
        return stipAxios.post(`${BASE_LINE_MANAGE}/itinerarios/pages/${page}/${size ? size : 10}`, request);
    },
    getItinerary: (cdLinhaItinerario) => stipAxios.get(`${BASE_LINE_MANAGE}/itinerarios/${cdLinhaItinerario}`),
    inativateItinerary: (cdLinhaItinerario) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/itinerarios/${cdLinhaItinerario}/inativar`),
    getItinerarySituations: (cdLinha) => stipAxios.get(`${BASE_LINE_MANAGE}/itinerarios/linha/${cdLinha}/situacoes`),
    saveItinerary: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/itinerarios/save`, data),
    getItineraryTypes: () => stipAxios.get(`${BASE_LINE_MANAGE}/itinerarios/tipos`),
    getLocations: () => stipAxios.get(`${BASE_LINE_MANAGE}/itinerarios/localidades`),
    saveItineraryLocations: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/itinerarios/localidades/save`, data),
    getSections: () => stipAxios.get(`${BASE_LINE_MANAGE}/itinerarios/secoes`),
    saveSections: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/itinerarios/secoes/save`, data),

    // Gestor Quadro de Horario ----------------------------------------------------------------
    getSchedules: (params) => {
        const { page, size, request } = params;
        return stipAxios.post(`${BASE_LINE_MANAGE}/quadros-horarios/pages/${page}/${size ? size : 10}`, request);
    },
    getSchedule: (cdLinhaQuadroHorario) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/quadros-horarios/${cdLinhaQuadroHorario}`),
    inativateSchedule: (cdLinhaQuadroHorario) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/quadros-horarios/${cdLinhaQuadroHorario}/inativar`),
    getScheduleSituations: (cdLinha) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/quadros-horarios/linha/${cdLinha}/situacoes`),
    saveSchedule: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/quadros-horarios/save`, data),
    generateScheduleFile: (cdLinhaQuadroHorario) =>
        stipAxios.get(`${BASE_LINE_MANAGE}/quadros-horarios/${cdLinhaQuadroHorario}/documento/gerar`),
    sendSchedulesToProcess: (data) =>
        stipAxios.post(`${BASE_LINE_MANAGE}/quadros-horarios/insere-documento-processo`, data),
    sendSchedulesToRequest: (data) =>
        stipAxios.post(`${BASE_LINE_MANAGE}/quadros-horarios/insere-documento-solicitacao`, data),
    getScheduleTypes: () => stipAxios.get(`${BASE_LINE_MANAGE}/quadros-horarios/tipos`),

    // Gestor Apostilas ----------------------------------------------------------------
    getAposttiles: (params) => {
        const { page, size, request } = params;
        return stipAxios.post(`${BASE_LINE_MANAGE}/apostilas/pages/${page}/${size ? size : 10}`, request);
    },
    getAposttile: (cdLinhaApostila) => stipAxios.get(`${BASE_LINE_MANAGE}/apostilas/${cdLinhaApostila}`),
    getAditamentos: () => stipAxios.get(`${BASE_LINE_MANAGE}/apostilas/aditamentos`),
    getBasesLegais: () => stipAxios.get(`${BASE_LINE_MANAGE}/apostilas/bases-legais`),
    inativateApostille: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/apostilas/inativar`, data),
    generateApostilleFile: (cdLinhaApostila) => stipAxios.get(`${BASE_LINE_MANAGE}/apostilas/${cdLinhaApostila}/gerar`),
    sendApostilleToProcess: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/apostilas/insere-documento-processo`, data),
    sendApostilleToRequest: (data) =>
        stipAxios.post(`${BASE_LINE_MANAGE}/apostilas/insere-documento-solicitacao`, data),
    saveApostille: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/apostilas/save`, data),

    // STRIP externo ------------------------------------------------------------------

    getLineLastApostille: (cdLinha) => {
        const baseUrl = `${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/apostila/primeira`;
        return stipAxios.get(`${baseUrl}/${cdLinha}`);
    },

    // Gestor Contrato ----------------------------------------------------------------

    getContracts: (params) => {
        const { page, size, request } = params;
        return stipAxios.post(`${BASE_LINE_MANAGE}/contratos/pages/${page}/${size ? size : 10}`, request);
    },
    getContract: (cdContratoTermoAditivo) => stipAxios.get(`${BASE_LINE_MANAGE}/contratos/${cdContratoTermoAditivo}`),
    saveContract: (data) => stipAxios.post(`${BASE_LINE_MANAGE}/contratos/save`, data),
    getContractType: () => stipAxios.get(`${BASE_LINE_MANAGE}/contratos/tipo-contrato`),
    getServiceType: () => stipAxios.get(`${BASE_LINE_MANAGE}/contratos/tipo-servico`),
    getLastContractsByLinha: (cdLinha, context = EXTERNAL_CONTEXT) => {
        let baseUrl = `${BASE_LINE_MANAGE}/contratos/ultimo-by-linha`;
        if (context === EXTERNAL_CONTEXT) baseUrl = `${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/ultimo-contrato`;
        return stipAxios.get(`${baseUrl}/${cdLinha}`);
    },
    getActiveContractByLine: (cdLinha) => stipAxios.get(`${BASE_LINE_MANAGE}/contrato-ativo/${cdLinha}`),
    getLineTransferTerms: (nuTermoTransferencia) =>
        stipAxios.post(`${BASE_LINE_MANAGE}/transferencias/termo`, { txtBusca: nuTermoTransferencia }),
};

export default lineEndpoints;
